<script lang="ts">
const messageCls = cva("animate-in fade-in-0 slide-in-from-top ease-out", {
	variants: {
		severity: {
			none: null,
			warning: "text-warning font-medium",
			error: "text-error font-medium",
		},
	},
});

interface Props extends BasePrimitiveProps {
	severity?: "error" | "warning" | "none";
}
</script>

<script setup lang="ts">
import { cva } from "class-variance-authority";
import { Primitive, useForwardExpose } from "reka-ui";
import type { BasePrimitiveProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

const { as = "div", severity = "none", ...props } = defineProps<Props>();

const { forwardRef } = useForwardExpose();
</script>

<template>
	<Primitive
		:ref="forwardRef"
		:as="as"
		:asChild="props.asChild"
		:class="cn(messageCls({ severity }), props.class)"
	>
		<slot />
	</Primitive>
</template>
